import { Flex, FlexProps, Text } from '@chakra-ui/react';
import { IconClock, IconCountdownTimer } from 'icons';
import { useEffect, useState } from 'react';

interface CountdownTimerProps {
  timeLeft: string;
  fontSize?: string;
  showMinutes?: boolean;
}

export const CountdownTimer = ({
  timeLeft,
  fontSize,
  showMinutes = true,
  ...rest
}: CountdownTimerProps & FlexProps) => {
  const [remainingTime, setRemainingTime] = useState('');

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const target = new Date(timeLeft);
      if (now > target) {
        setRemainingTime('0h 0m');
        return
      }
      const difference = target.getTime() - now.getTime();
      if (difference > 0) {
        const hours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        if (hours >= 24) {
          const days = Math.floor(hours / 24);
          const remainingHours = hours % 24;
          if (showMinutes) {
            setRemainingTime(`${days}d ${remainingHours}h ${minutes}m`);
          } else {
            setRemainingTime(`${days}d ${remainingHours}h`);
          }
        } else {
          setRemainingTime(`${hours}h ${minutes}m`);
        }
      } else {
        setRemainingTime('0h 0m');
      }
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 60000); // Atualiza a cada minuto
    return () => clearInterval(interval);
  }, [timeLeft, showMinutes]);

  return (
    <Flex
      bg="linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)"
      borderRadius="4px"
      p="0px 2px"
      align="center"
      {...rest}
    >
      <IconCountdownTimer 
        w="16px" 
        h="16px" 
        mr="1" 
        __css={{
          path: {
            fill: 'white.80',
          },
        }}
      />
      <Text
        as="i"
        fontWeight="bold"
        fontSize={{ base: '10px', md: fontSize || '14px' }}
        color="white.80"
      >
        {remainingTime}
      </Text>
    </Flex>
  );
};
